import type { Offering } from '../types/api'

/**
 * The tooltip lines for a dot: one per category, "Category · its own sub-categories". Falls back to
 * the flat category and subject lists when the server sent no breakdown.
 */
export function offeringLines(offerings: Offering[] | undefined, category?: string, subjects: string[] = []): string[] {
  const fromOfferings = (offerings ?? [])
    .map((o) => [o.category, o.items.join(', ')].filter(Boolean).join(' · '))
    .filter(Boolean)
  if (fromOfferings.length > 0) return fromOfferings
  const flat = [category, subjects.join(', ')].filter(Boolean).join(' · ')
  return flat ? [flat] : []
}
